"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRevokeInstruction = exports.revokeInstructionDiscriminator = exports.RevokeStruct = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const RevokeArgs_1 = require("../types/RevokeArgs");
exports.RevokeStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['revokeArgs', RevokeArgs_1.revokeArgsBeet],
], 'RevokeInstructionArgs');
exports.revokeInstructionDiscriminator = 45;
function createRevokeInstruction(accounts, args, programId = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [data] = exports.RevokeStruct.serialize({
        instructionDiscriminator: exports.revokeInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: (_a = accounts.delegateRecord) !== null && _a !== void 0 ? _a : programId,
            isWritable: accounts.delegateRecord != null,
            isSigner: false,
        },
        {
            pubkey: accounts.delegate,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.metadata,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: (_b = accounts.masterEdition) !== null && _b !== void 0 ? _b : programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_c = accounts.tokenRecord) !== null && _c !== void 0 ? _c : programId,
            isWritable: accounts.tokenRecord != null,
            isSigner: false,
        },
        {
            pubkey: accounts.mint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_d = accounts.token) !== null && _d !== void 0 ? _d : programId,
            isWritable: accounts.token != null,
            isSigner: false,
        },
        {
            pubkey: accounts.authority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: accounts.payer,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: (_e = accounts.systemProgram) !== null && _e !== void 0 ? _e : web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.sysvarInstructions,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_f = accounts.splTokenProgram) !== null && _f !== void 0 ? _f : programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_g = accounts.authorizationRulesProgram) !== null && _g !== void 0 ? _g : programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_h = accounts.authorizationRules) !== null && _h !== void 0 ? _h : programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createRevokeInstruction = createRevokeInstruction;
//# sourceMappingURL=Revoke.js.map